import { AxiosError } from 'axios';

import { getApiClient } from './api.base';
import { FundraisingSearchResponse } from '@/models/fundraising-search-response.model';

type Response = FundraisingSearchResponse & AxiosError;

export const fundraisingSearchService = async (
  query: string
): Promise<Response> => {
  try {
    const response = await getApiClient('search').get(
      `/api/v1/fundraising/search?${query}`
    );
    return response.data as Response;
  } catch (errorResponse) {
    const error = errorResponse as Response;
    console.info(error);
    return error;
  }
};
